var _rect, _rect2, _rect3, _g, _rect4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturesTwoUpholstered3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "232.4px",
    height: "302px",
    viewBox: "0 0 232.4 302",
    enableBackground: "new 0 0 232.4 302",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 37.6,
    fill: "none",
    stroke: "#646463",
    strokeWidth: 1.7568,
    strokeMiterlimit: 10,
    width: 198.4,
    height: 226.8
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 31.2,
    y: 51.8,
    fill: "none",
    stroke: "#646463",
    strokeWidth: 1.7321,
    strokeMiterlimit: 10,
    width: 170.1,
    height: 198.4
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 131.8,
    y: 62.8,
    fill: "#494848",
    width: 0,
    height: 38.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 1.0019,
    strokeMiterlimit: 10,
    d: "M34.1,192c0,0-0.4,0.2-0.4,0.7 c0,0.5-0.1,2.3-0.1,2.3s0,0.5,0.6,0.7c0.6,0.2,3.8,0.9,4.8,1.2s7.5,2,9.3,2.3s9.3,1.7,10.9,1.9c1.5,0.2,13,1.4,15.3,1.5 c2.2,0.1,5,0,6.6,0c1.6,0,6.6-0.7,9.9-1c1.7-0.1,6-0.9,6.9-1.1c0.8-0.2,11.9-3.1,12.5-3.3c0.6-0.2,4.9-1.5,5.2-1.6 s0.5-0.2,0.6-0.8s0.1-1.8,0.1-1.8s0.1-0.3-0.1-0.4c-0.1-0.1-0.5-0.3-0.5-0.3l-8.4,2.2l-10.9,2l-8.3,1.9L76.5,199l-17-1.9L43,194.1 l-8.7-2.3L34.1,192z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 1.0019,
    strokeMiterlimit: 10,
    d: "M34.3,188.3c0,0-0.6,0.3-0.6,0.8 c0,0.5,0,2.2,0,2.2s-0.2,0.4,0.4,0.6c0.6,0.2,3.9,1.3,4.8,1.5s10,2.2,12,2.7c2,0.4,13.8,2.3,16.8,2.5s11.7,0.9,11.7,0.9 s8.1-0.6,10.1-0.8s9.4-2,11.2-2.4c1.8-0.3,11.8-2.7,13.3-3.1c1.5-0.4,1.9-0.6,1.9-0.6s0.5,0,0.5-1c0-1,0-1.8,0-1.8 s-0.1-0.7-0.6-0.7c-0.5,0-0.5-0.3-0.5-0.3l-5.4,1.5L94,194.1l-11.3,1.7l-5.9-0.1l-7.8-0.2l-9.8-1.3l-13.4-2.6l-9.5-2.9l-1.7-0.5 L34.3,188.3z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 1.0019,
    strokeMiterlimit: 10,
    d: "M34.2,184.2c0,0-0.7,0.3-0.7,1.3 c0,1,0,1.6,0,1.6s-0.2,0.7,0.7,1.1c0.9,0.4,5.8,2,7,2.3s14.5,3.6,17.6,4c3.1,0.4,15.2,1.8,21.7,1.6c6.4-0.1,14.2-1.7,15.4-1.9 s7.6-1.9,8.7-2.2c1-0.2,10.3-3,11-3.2c0.6-0.2,0.6-0.3,0.6-1.3s0.1-1.7-0.3-2.2s-0.8-0.7-0.8-0.7l-0.5-0.4L97,188.6l-9.3,1.7 l-10.2,0.5l-8.9-0.8l-12.2-1.9l-21.7-4.3L34.2,184.2z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 1.0019,
    strokeMiterlimit: 10,
    d: "M34,70h81.1v102.3c0,0,1.1,4.1,1.1,6.5 c0,2.3,0,4,0,4s0.3,1.2-1.6,1.7s-7.5,2.3-11.9,3.2c-6.4,1.4-14.3,3-17.1,3.1c-2.8,0.1-7.4,0.5-13.2,0s-22.3-3.2-25.4-3.8 c-3.1-0.7-11.7-2.8-12.5-3.1c-0.8-0.2-1.4-0.6-1.1-3.2c0.3-2.6,0.8-5.7,0.8-7.1C34.1,172.2,34,70,34,70z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 1.0019,
    strokeMiterlimit: 10,
    d: "M117.4,218.6c0,0-0.4,0.2-0.4,0.7 c0,0.5-0.1,2.3-0.1,2.3s0,0.5,0.6,0.7s3.8,0.9,4.8,1.2c1,0.2,7.5,2,9.3,2.3c1.8,0.3,9.3,1.7,10.9,1.9c1.5,0.2,13,1.4,15.3,1.5 c2.2,0.1,5,0,6.6,0c1.6,0,6.6-0.7,9.9-1c1.7-0.1,6-0.9,6.9-1.1c0.8-0.2,11.9-3.1,12.5-3.3c0.6-0.2,4.9-1.5,5.2-1.6 s0.5-0.2,0.6-0.8c0.1-0.6,0.1-1.8,0.1-1.8s0.1-0.3-0.1-0.4c-0.1-0.1-0.5-0.3-0.5-0.3l-8.4,2.2l-10.9,2l-8.3,1.9l-11.3,0.6l-17-1.9 l-16.4-3.1l-8.7-2.3L117.4,218.6z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 1.0019,
    strokeMiterlimit: 10,
    d: "M117.6,214.9c0,0-0.6,0.3-0.6,0.8 c0,0.5,0,2.2,0,2.2s-0.2,0.4,0.4,0.6c0.6,0.2,3.9,1.3,4.8,1.5c0.9,0.2,10,2.2,12,2.7c2,0.4,13.8,2.3,16.8,2.5 c2.9,0.2,11.7,0.9,11.7,0.9s8.1-0.6,10.1-0.8c2-0.2,9.4-2,11.2-2.4c1.8-0.3,11.8-2.7,13.3-3.1c1.5-0.4,1.9-0.6,1.9-0.6 s0.5,0,0.5-1s0-1.8,0-1.8s-0.1-0.7-0.6-0.7s-0.5-0.3-0.5-0.3l-5.4,1.5l-15.7,3.9l-11.3,1.7l-5.9-0.1l-7.8-0.2l-9.8-1.3l-13.4-2.6 l-9.5-2.9l-1.7-0.5L117.6,214.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 1.0019,
    strokeMiterlimit: 10,
    d: "M117.6,210.7c0,0-0.7,0.3-0.7,1.3 c0,1,0,1.6,0,1.6s-0.2,0.7,0.7,1.1c0.9,0.4,5.8,2,7,2.3c1.2,0.3,14.5,3.6,17.6,4c3.1,0.4,15.2,1.8,21.7,1.6s14.2-1.7,15.4-1.9 c1.2-0.1,7.6-1.9,8.7-2.2c1-0.2,10.3-3,11-3.2s0.6-0.3,0.6-1.3c0-0.9,0.1-1.7-0.3-2.2c-0.4-0.5-0.8-0.7-0.8-0.7l-0.5-0.4 l-17.6,4.4l-9.3,1.7l-10.2,0.5l-8.9-0.8l-12.2-1.9l-21.7-4.3L117.6,210.7z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E3E2",
    stroke: "#626262",
    strokeWidth: 1.0019,
    strokeMiterlimit: 10,
    d: "M117.4,66.3h81.1v132.6 c0,0,1.1,4.1,1.1,6.5c0,2.3,0,4,0,4s0.3,1.2-1.6,1.7s-7.5,2.3-11.9,3.2c-6.4,1.4-14.3,3-17.1,3.1c-2.8,0.1-7.4,0.5-13.2,0 c-5.8-0.5-22.3-3.2-25.4-3.8c-3.1-0.7-11.7-2.8-12.5-3.1c-0.8-0.2-1.4-0.6-1.1-3.2c0.3-2.6,0.8-5.7,0.8-7.1S117.4,66.3,117.4,66.3 z"
  })))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 31.2,
    y: 51.8,
    fill: "#E3E3E2",
    stroke: "#B2B2B2",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    width: 170.1,
    height: 19.8
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesTwoUpholstered3);
export default __webpack_public_path__ + "static/media/FeaturesTwoUpholstered3.633a209fa03d2c4422115d07630a31c0.svg";
export { ForwardRef as ReactComponent };